// check if an element is in viewport
function isInViewport(el) {
  const rect = el.getBoundingClientRect();

  return (
    rect.top >= 0 &&
    rect.left >= 0 &&
    rect.right <= (window.innerWidth || document.documentElement.clientWidth) &&
    rect.bottom <= (window.innerHeight || document.documentElement.clientHeight)
  );
}

// handle fade-in animation on scroll in the homepage
function handleIfHomepageSectionExistsOnScreen() {
  if (location.pathname === "/") {
    const shownSections = [];

    const observer = ElementVisilibityObserver(
      ElementVisilibityObserverCallback
    );

    const sections = document.querySelectorAll("#MainContent > *");

    if (sections.length === 0) return;

    /**
     * Handles if an element exists in the viewport on scroll
     * @param {(entry: IntersectionObserverEntry) => any} callback
     */
    function ElementVisilibityObserver(callback) {
      return new IntersectionObserver((entries) => callback(entries[0]), {
        threshold: [0],
      });
    }

    /**
     * @param {IntersectionObserverEntry} entry
     */
    function ElementVisilibityObserverCallback(entry) {
      if (entry.isIntersecting && !shownSections.includes(entry.target)) {
        const scrollingFrom = scrollPosition(entry);
        const _class = `fade-in-from-${scrollingFrom.top ? "top" : "bottom"}`;

        shownSections.push(entry.target);

        entry.target.classList.add(_class);
        setTimeout(() => {
          entry.target.classList.remove(_class);
        }, 1000);
      } else {
      }
    }

    function scrollPosition(entry) {
      return {
        top: entry.boundingClientRect.top >= 0,
        bottom: entry.boundingClientRect.top < 0,
      };
    }

    sections.forEach((section) => {
      observer.observe(section);

      // prevent animation if section is already visible on screen
      const position = section.getBoundingClientRect();
      if (position.top < window.innerHeight && position.bottom >= 0) {
        shownSections.push(section);
      }
    });
  }
}

// handle navigation linked-list design
function handleHeaderNavigationChildLinksStyle() {
  const menus = document.querySelectorAll(
    ".header-wrapper details > .header__submenu"
  );
  if (menus.length === 0) return;

  menus.forEach((menu) => {
    const childNodes = menu.childNodes;
    if (childNodes.length === 0) return;

    const childElementNodes = [];
    childNodes.forEach((child) => {
      if (child instanceof HTMLElement) {
        childElementNodes.push(child);
      }
    });
    if (childElementNodes.length === 0) return;

    const filteredChildElementNodes = childElementNodes.filter(
      (child) => child.firstElementChild instanceof HTMLSpanElement
    );
    if (filteredChildElementNodes.length === 0) return;

    menu.classList.add("with-extended-children");
  });
}

// main-product.liquid
function handleMainProductMedia() {
  if (!location.pathname.includes("products")) return;

  const wrapper = document.getElementById("product-media-wrapper");
  const wrapperInnerHTML = wrapper.innerHTML;

  const handleImagesWrapper = () => {
    if (window.innerWidth <= 750) {
      if (wrapper.innerHTML !== wrapperInnerHTML) {
        wrapper.innerHTML = wrapperInnerHTML;
      }
    } else {
      if (!wrapper.querySelector(".d-w--40")) {
        const mediaWrapper = wrapper.querySelector("ul");

        // carousel position index
        let index = 0;

        // all product images
        const imageElements = mediaWrapper.querySelectorAll("img");
        if (imageElements.length === 0) return;

        // get all product sources and alt
        let imageSources = [];
        imageElements.forEach((el) =>
          imageSources.push({ src: el.src, alt: el.alt })
        );
        imageSources = imageSources.filter(
          (r, i, s) => i === s.findIndex((t) => t.src === r.src)
        );

        mediaWrapper.classList.add("d-w--60");

        // display all product sources and alt as thumbnails
        const thumbnailsWrapper = document.createElement("ul");
        thumbnailsWrapper.classList.add("d-w--40");
        thumbnailsWrapper.classList.add("thumbnails--wrapper");
        if (imageSources.length <= 1)
          thumbnailsWrapper.style.visibility = "hidden";
        imageSources.forEach(({ src, alt }, i) => {
          const img = document.createElement("img");
          img.src = src;
          img.alt = alt;

          const li = document.createElement("li");
          if (i === 0) li.className = "visible";
          li.dataset.positionIndex = i;
          li.addEventListener("click", () => scrollTo(i));
          li.appendChild(img);

          thumbnailsWrapper.appendChild(li);
        });

        // add the thumbnail wrapper before the existing media wrapper
        mediaWrapper.parentNode.insertBefore(
          thumbnailsWrapper,
          mediaWrapper.previousSibling
        );

        // carousel wrapper
        wrapper.firstElementChild.style.position = "relative";
        mediaWrapper.style.justifyContent = "flex-start";
        mediaWrapper.style.flexWrap = "nowrap";
        mediaWrapper.style.overflow = "hidden";

        let maxHeight = 0;

        const mediaWrapperChildren = mediaWrapper.querySelectorAll("li");
        if (mediaWrapperChildren.length === 0) return;
        mediaWrapperChildren.forEach((child) => {
          const modal = child.querySelector("modal-opener");
          if (modal.offsetHeight > maxHeight) {
            maxHeight = modal.offsetHeight;
          }

          child.style.width = "100%";
          child.style.position = "relative";
          child.style.zIndex = 0;

          // dark overlay for arrows
          const span = document.createElement("span");
          span.style.cssText =
            "position: absolute; top: 0; right: 0; z-index: 0; height: 100%; width: 100%; background: linear-gradient(90deg, #14141425 0%, #ffffff11 50%, #14141425 100%)";
          child.querySelector(".media").appendChild(span);
        });

        thumbnailsWrapper.style.maxHeight = maxHeight + "px";

        function slideNext() {
          if (index < mediaWrapperChildren.length - 1) {
            index += 1;
          }

          scrollTo(index);
        }

        function slidePrevious() {
          if (index > 0) {
            index -= 1;
          }

          scrollTo(index);
        }

        function scrollTo(i) {
          const thumbnailsWrapperChildNodes = thumbnailsWrapper.childNodes;
          for (let j = 0; j < thumbnailsWrapperChildNodes.length; j++) {
            const currentThumbnail = thumbnailsWrapperChildNodes[j];

            if (Number(currentThumbnail.dataset.positionIndex) === i) {
              currentThumbnail.className = "visible";
            } else {
              currentThumbnail.className = "";
            }
          }

          mediaWrapper.scroll({
            left: mediaWrapperChildren[i].offsetWidth * i,
            behavior: "smooth",
          });

          index = i;
        }

        // carousel arrows
        function createArrow(direction, onclick) {
          const span = document.createElement("span");

          const leftArrow =
            `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M18.0473 20L26.2973 28.25L23.9406 30.6066L13.334 20L23.9406 9.39331L26.2973 11.75L18.0473 20Z" fill="white"/>
            </svg>`.trim();

          const rightArrow =
            `<svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M21.9531 20L13.7031 11.75L16.0598 9.39331L26.6665 20L16.0598 30.6066L13.7031 28.25L21.9531 20Z" fill="white"/>
            </svg>`.trim();

          span.innerHTML = direction === "left" ? leftArrow : rightArrow;
          span.addEventListener("click", onclick);
          span.style.cssText = `position: absolute; top: ${
            maxHeight / 2
          }px; cursor: pointer;`;
          span.style.cssText +=
            direction === "left"
              ? "left: calc(40% + 1.8rem);"
              : "left: calc(100% - 4rem);";

          wrapper.firstElementChild.appendChild(span);
        }
        if (imageSources.length > 1) {
          createArrow("left", slidePrevious);
          createArrow("right", slideNext);
        }
      }
    }
  };

  handleImagesWrapper();

  window.addEventListener("resize", handleImagesWrapper);
}

// account.liquid
function handleAccountSectionVisibility() {
  if (location.pathname !== "/account") return;

  const section = {
    /** @type {HTMLDivElement} */
    addresses: document.querySelector(".account--customer-addresses"),
    /** @type {HTMLDivElement} */
    orders: document.querySelector(".account--customer-orders"),
  };

  const button = {
    /** @type {HTMLParagraphElement} */
    addresses: document.getElementById("addresses-button"),
    /** @type {HTMLParagraphElement} */
    orders: document.getElementById("orders-button"),
  };

  const parent = button.addresses.parentElement;

  button.addresses.addEventListener("click", () =>
    handleOnButtonClick("addresses")
  );
  button.orders.addEventListener("click", () => handleOnButtonClick("orders"));

  function handleOnButtonClick(label) {
    if (label === "addresses") {
      section.addresses.classList.add("visible");
      section.orders.classList.remove("visible");

      button.addresses.classList.add("selected");
      button.orders.classList.remove("selected");

      parent.classList.remove("orders-selected");
    } else {
      section.addresses.classList.remove("visible");
      section.orders.classList.add("visible");

      button.addresses.classList.remove("selected");
      button.orders.classList.add("selected");

      parent.classList.add("orders-selected");
    }
  }
}

// account.liquid
function handleAccountAddresses() {
  const addNewAddressButton = document.getElementById("add-new-address-button");
  const addAddressContainer = document.getElementById("add-address-container");

  if (!addNewAddressButton) return;

  addNewAddressButton.addEventListener("click", () =>
    addNewAddressToggle(addAddressContainer)
  );
  addAddressContainer
    .querySelector('button[type="reset"]')
    .addEventListener("click", () => addNewAddressToggle(addAddressContainer));

  const addresses = document.querySelectorAll(
    ".account--customer-addresses > ul li[data-address]"
  );
  if (addresses.length === 0) return;

  addresses.forEach((address) => {
    const form = address.querySelector("form");
    form.style.display = "none";

    // edit button handler
    const editButton = address.querySelector('button[name="edit"]');
    editButton.addEventListener("click", () => editAddress(address));
    // cancel button handler
    const cancelButton = address.querySelector('button[type="reset"]');
    cancelButton.addEventListener("click", () => editAddress(address));
    // delete button handler
    const deleteButton = address.querySelector('button[name="delete"]');
    deleteButton.addEventListener("click", (e) =>
      deleteAddress(
        e.target.dataset.confirmMessage,
        e.target.dataset.addressUrl
      )
    );
  });

  function addNewAddressToggle(container) {
    const isVisible = container?.style.display !== "none";
    container.style.display = isVisible ? "none" : "block";
  }

  /**
   * @param {HTMLLIElement} address
   */
  function editAddress(address) {
    const form = address.querySelector("form");
    const div = address.querySelector(".address-info");

    const isFormVisible = form.style.display !== "none";

    if (isFormVisible) {
      form.style.display = "none";
      div.style.display = "block";
    } else {
      form.style.display = "block";
      div.style.display = "none";
    }
  }

  function deleteAddress(confirmMsg, url) {
    const isConfirmed = confirm(confirmMsg);
    if (!isConfirmed) return;

    fetch(url, { method: "delete" })
      .then(() => location.reload())
      .catch(() => location.reload());
  }
}

// main-collection-product-grid.liquid
function handleProductFilteringOnBigScreens() {
  if (
    !(
      location.pathname.includes("collections") ||
      location.pathname.includes("search")
    )
  ) {
    return;
  }

  const filterButton = document.querySelector(".mobile-facets__open-wrapper");
  if (!filterButton) return;

  const filtersForm = filterButton.nextElementSibling.firstElementChild;
  if (!filtersForm) return;

  const innerHTML = filtersForm.innerHTML;

  const elements = getFilterElements();
  if (elements.length === 0) return;

  const footer = document.querySelector(".mobile-facets__footer");
  const button = {
    clear: footer.firstElementChild,
    submit: footer.firstElementChild.nextElementSibling,
  };
  if (!button.clear || !button.submit) return;

  /**
   * get all filter elements with their respective title as array of objects
   * @returns { {title: string, items: HTMLLIElement[] }[]}
   */
  function getFilterElements() {
    const container = filterButton.nextElementSibling;
    if (!container) return;

    const innerContainer = container.querySelectorAll(
      ".mobile-facets__submenu"
    );
    if (!innerContainer) return;

    const elements = [];

    innerContainer.forEach((innerContainer) => {
      const obj = {
        title: innerContainer.firstElementChild.textContent
          .replaceAll("\\n", "")
          .trim(),
        items: [],
      };

      let ul = innerContainer.querySelector("ul");
      if (!ul) ul = innerContainer;
      if (!ul) return;

      let items = ul.querySelectorAll("li");
      if (items.length === 0) items = ul.querySelectorAll(".facets__price");

      items.forEach((item) => obj.items.push(item));

      elements.push(obj);
    });

    return elements;
  }

  function getHydratedFacetsForm() {
    let html = "";

    elements.forEach((element) => {
      const section = document.createElement("section");

      section.innerHTML = `<p>${element.title}</p>`;

      const ul = document.createElement("ul");
      element.items.forEach((item) => ul.appendChild(item));

      section.appendChild(ul);

      html += section.outerHTML;
    });

    const closeButton = document.createElement("span");
    closeButton.style =
      "position: absolute; top: 1rem; right: 1rem; font-size: 24px; cursor: pointer;";
    closeButton.innerHTML = "&times;";
    closeButton.setAttribute(
      "onclick",
      "document.querySelector('.mobile-facets__open-wrapper.focus-offset').click()"
    );

    html += closeButton.outerHTML;

    return html;
  }

  filtersForm.innerHTML = "";

  function handleWindowResize() {
    if (window.innerWidth <= 1200) {
      if (filtersForm.innerHTML !== innerHTML) {
        filterButton.parentElement.classList.remove("desktop");
        filtersForm.classList.remove("desktop");
        filtersForm.innerHTML = innerHTML;
      }
    } else {
      if (filtersForm.innerHTML !== getHydratedFacetsForm()) {
        filterButton.parentElement.classList.add("desktop");
        filtersForm.classList.add("desktop");
        filtersForm.innerHTML = getHydratedFacetsForm();
      }
    }
  }

  handleWindowResize();
  window.addEventListener("resize", handleWindowResize);
}

// footer.liquid
function handleFooterDropdownsOnPhone() {
  const footer = document.querySelector("footer.footer");
  if (!footer) return;

  let children = Array.from(
    footer.querySelectorAll(
      ".footer-block.grid__item.footer-block--menu > .footer-block-item-container"
    )
  );
  if (!children?.length) return;

  const outerHTMLs = new Array(children.length)
    .fill()
    .map((_, i) => children[i].outerHTML);

  function handler() {
    children = Array.from(
      footer.querySelectorAll(
        ".footer-block.grid__item.footer-block--menu > .footer-block-item-container"
      )
    );
    if (!children?.length) return;

    if (window.innerWidth > 750) {
      if (children.filter((r, i) => r.outerHTML !== outerHTMLs[i]).length > 0) {
        children.forEach((r, i) => (r.outerHTML = outerHTMLs[i]));
      }
    } else {
      const filter = children.filter((r) => !(r instanceof HTMLDetailsElement));
      if (filter.length === 0) return;

      filter.forEach((child, i, self) => {
        const details = document.createElement("details");
        details.className = child.className;
        details.classList.add("footer-details-dropdown");

        if (i < self.length - 1) {
          details.style.borderBottom = "1px solid #ffffff29";
        }

        const summary = document.createElement("summary");
        const { firstElementChild } = child;
        summary.className = firstElementChild.className;
        summary.innerHTML = firstElementChild.outerHTML;
        summary.style.width = "100%";

        const span = document.createElement("span");
        span.className = "footer-details-dropdown-icon";
        summary.appendChild(span);

        details.appendChild(summary);
        details.appendChild(firstElementChild.nextElementSibling);

        child.parentElement.replaceChild(details, child);
      });
    }
  }

  handler();
  window.addEventListener("resize", handler);
}

function handleNavbarDetailsDropdownOnHover() {
  const header = document.querySelector("sticky-header");
  const details = Array.from(
    header.querySelectorAll(
      ".header > .right details-disclosure > details, .header > .header__inline-menu details-disclosure > details"
    )
  );

  details.forEach((el) => {
    const onMouseEnter = (e) => {
      details.forEach((r) => r.removeAttribute("open"));
      el.firstElementChild.click();
    };

    const onMouseLeave = (e) => {
      el.firstElementChild.click();
    };

    el.firstElementChild.addEventListener("mouseenter", onMouseEnter);
    el.firstElementChild.nextElementSibling.addEventListener(
      "mouseleave",
      onMouseLeave
    );
  });
}

function handleCollectionAnchorTags() {
  const as = document.querySelectorAll("a");

  as.forEach((a) => {
    const href = a.href;

    const hasCollection = href.includes("collection");
    const hasQuestionMark = href.includes("?");
    const hasAmpersand = href.includes("&");
    const isFacetRemove = a.classList.contains("mobile-facets__clear");

    if (hasCollection && !hasQuestionMark && !hasAmpersand && !isFacetRemove) {
      a.href = href + "?filter.v.availability=1";
    }
  });
}

// listeners
window.addEventListener("DOMContentLoaded", () => {
  handleIfHomepageSectionExistsOnScreen();
  handleHeaderNavigationChildLinksStyle();
  handleMainProductMedia();
  handleAccountSectionVisibility();
  handleAccountAddresses();
  handleProductFilteringOnBigScreens();
  handleFooterDropdownsOnPhone();
  // handleCollectionAnchorTags();
  handleNavbarDetailsDropdownOnHover();
});

// image-slider.liquid -- wrapper element
class ImageSlider extends HTMLElement {
  /** @type {HTMLDivElement} */
  header;

  // animation speed
  speed;

  men = {
    /** @type {HTMLSpanElement} */
    button: undefined,
    /** @type {HTMLDivElement} */
    section: undefined,
  };

  women = {
    /** @type {HTMLSpanElement} */
    button: undefined,
    /** @type {HTMLDivElement} */
    section: undefined,
  };

  /** @type {HTMLAnchorElement} */
  desktopButton;

  constructor() {
    super();

    window.addEventListener("DOMContentLoaded", () => {
      this.onDOMContentLoaded();
    });

    window.addEventListener("load", () => {
      this.onWindowLoad();
    });
  }

  onDOMContentLoaded() {
    this.header = this.querySelector("#image-slider-header");
    this.desktopButton = this.querySelector(".desktop-button");

    this.handleMenCollection();
    this.handleWomenCollection();
  }

  onWindowLoad() {
    this.speed = Number(this.dataset.animationSpeed);

    this.handleInfiniteSlider(this.men.section);
    this.handleInfiniteSlider(this.women.section);
  }

  handleMenCollection() {
    this.men = {
      button: this.header.firstElementChild,
      section: this.querySelector('[data-slider-label="men"]'),
    };

    this.men.button.addEventListener("click", () =>
      this.handleCollectionVisibilty("men")
    );
  }

  handleWomenCollection() {
    this.women = {
      button: this.header.firstElementChild.nextElementSibling,
      section: this.querySelector('[data-slider-label="women"]'),
    };

    this.women.button.addEventListener("click", () =>
      this.handleCollectionVisibilty("women")
    );
  }

  handleCollectionVisibilty(section) {
    if (section === "men") {
      this.women.section.className = "image-section";
      this.women.button.className = "";

      this.men.section.className = "image-section visible fade-in";
      this.men.button.className = "active";

      this.desktopButton.href = this.men.button.dataset.collectionButtonUrl;
    } else {
      this.women.section.className = "image-section visible fade-in";
      this.women.button.className = "active";

      this.men.section.className = "image-section";
      this.men.button.className = "";

      this.desktopButton.href = this.women.button.dataset.collectionButtonUrl;
    }
  }

  /**
   * @param {HTMLDivElement} slider
   */
  handleInfiniteSlider(slider) {
    // handles the position of the slider
    let translateX_value = 0;
    // checks whether the animation should play
    let should_animation_play = false;
    // all image sources
    const items = [];
    // all children of the slider
    const children = slider.querySelectorAll("a");
    // safe check
    if (children.length === 0) return;
    // get all items from slider children
    children.forEach((child, i) => {
      const { src, alt, clientWidth } = child.querySelector("img");

      items.push({ href: child.href, src, alt });

      if (i < 2) translateX_value += clientWidth;
    });
    // if an image is not in viewport, let the animation play
    for (let i = 0; i < children.length; i++) {
      if (!isInViewport(children[i])) {
        should_animation_play = true;
        break;
      }
    }
    // stop the code from running if animation shouldn't play
    if (!should_animation_play) return;

    // hydrate all items extended
    slider.style.justifyContent = "flex-start";
    if (children.length % 2 === 1) items.push(...items);
    items.push(...items);
    items.push(...items);

    while (slider.firstChild) slider.firstChild.remove();

    items.forEach(({ href, src, alt }, i) => {
      const a = document.createElement("a");
      a.href = href;
      a.className = i % 2 === 0 ? "small" : "";

      const img = new Image();
      img.src = src;
      img.alt = alt;

      a.appendChild(img);
      slider.appendChild(a);
    });

    // animation play
    const playAnimation = () => {
      slider.style.transition = "transform 0s linear";
      slider.style.transform = "translateX(0)";

      void slider.offsetWidth;

      slider.style.transition = `transform ${this.speed}s linear`;
      slider.style.transform = `translateX(-${
        translateX_value * (items.length / 2 / 2 / 2)
      }px)`;
    };

    requestAnimationFrame(playAnimation);

    setInterval(() => {
      requestAnimationFrame(playAnimation);
    }, this.speed * 1000);
  }
}
customElements.define("section-image-slider", ImageSlider);

// double-banner.liquid
class DoubleBanner extends HTMLElement {
  constructor() {
    super();

    window.addEventListener("DOMContentLoaded", () => {
      this.onDOMContentLoaded();
    });
  }

  onDOMContentLoaded() {}
}
customElements.define("section-double-banner", DoubleBanner);

// collection-list-v2.liquid
class CollectionListV2 extends HTMLElement {
  /** @type {HTMLDivElement} */
  header;

  men = {
    /** @type {HTMLSpanElement} */
    button: undefined,
    /** @type {HTMLDivElement} */
    section: undefined,
  };

  women = {
    /** @type {HTMLSpanElement} */
    button: undefined,
    /** @type {HTMLDivElement} */
    section: undefined,
  };

  constructor() {
    super();

    window.addEventListener("DOMContentLoaded", () => {
      this.onDOMContentLoaded();
    });
  }

  onDOMContentLoaded() {
    this.header = this.querySelector("#collection-v2-header");

    this.handleMenCollection();
    this.handleWomenCollection();
  }

  handleMenCollection() {
    this.men = {
      button: this.header.firstElementChild,
      section: this.querySelector(
        'section[data-collection-container-label="men"]'
      ),
    };

    this.men.button.addEventListener("click", () =>
      this.handleCollectionVisibilty("men")
    );
  }

  handleWomenCollection() {
    this.women = {
      button: this.header.firstElementChild.nextElementSibling,
      section: this.querySelector(
        'section[data-collection-container-label="women"]'
      ),
    };

    this.women.button.addEventListener("click", () =>
      this.handleCollectionVisibilty("women")
    );
  }

  handleCollectionVisibilty(section) {
    if (section === "men") {
      this.women.section.className = "collection-grid";
      this.women.button.className = "";

      this.men.section.className = "collection-grid visible";
      this.men.button.className = "active";
    } else {
      this.women.section.className = "collection-grid visible";
      this.women.button.className = "active";

      this.men.section.className = "collection-grid";
      this.men.button.className = "";
    }
  }
}
customElements.define("section-collection-list-v2", CollectionListV2);

// custom-image-banner.liquid
class CustomImageBanner extends HTMLElement {
  constructor() {
    super();

    window.addEventListener("DOMContentLoaded", () => {
      const playAnimation = () => {
        if (window.innerWidth > 750) {
          this.onDOMContentLoaded();
        }
      };

      playAnimation();
      window.addEventListener("resize", playAnimation);
    });
  }

  onDOMContentLoaded() {
    const container = this.querySelector("#banner-container");

    if (container.childNodes.length <= 1) return;

    const imageElements = [];
    let index = 0;

    while (container.firstChild) {
      if (container.firstChild instanceof HTMLElement)
        imageElements.push(container.firstChild);
      container.firstChild.remove();
    }

    const playAnimation = () => {
      while (container.firstChild) {
        container.firstChild.remove();
      }

      container.appendChild(imageElements[index]);

      index = index < imageElements.length - 1 ? index + 1 : 0;
    };

    playAnimation();

    setInterval(() => {
      requestAnimationFrame(playAnimation);
    }, Number(this.dataset.animationSpeed) * 1000);
  }
}
customElements.define("custom-image-banner", CustomImageBanner);

// banner-carousel.liquid
class BannerCarousel extends HTMLElement {
  constructor() {
    super();

    this.prevToggle = "left";

    window.addEventListener("DOMContentLoaded", () =>
      this.onDOMContentLoaded()
    );
  }

  onDOMContentLoaded() {
    this.elements = {
      left: {
        sections: Array.from(
          this.querySelectorAll('[data-section-type="left"]')
        ),
        button: this.querySelector('[data-button-type="left"]'),
      },
      right: {
        sections: Array.from(
          this.querySelectorAll('[data-section-type="right"]')
        ),
        button: this.querySelector('[data-button-type="right"]'),
      },
    };

    this.adaptToFirstImage = this.dataset.adaptToFirstImage === "true";
    this.transitionSpeed = Number(this.dataset.transitionSpeed);
    this.intervalSpeed = Number(this.dataset.intervalSpeed);

    this.elements.left.button.addEventListener("click", () =>
      this.handleSectionVisibility("left")
    );
    this.elements.right.button.addEventListener("click", () =>
      this.handleSectionVisibility("right")
    );

    [...this.elements.left.sections, ...this.elements.right.sections].forEach(
      (section) => {
        this.handlePlayState(section);
      }
    );
  }

  handleSectionVisibility(section) {
    if (section === this.prevToggle) return;

    this.elements.left.sections.forEach((section) => {
      section.classList.toggle("fade-in");
    });

    this.elements.right.sections.forEach((section) => {
      section.classList.toggle("fade-in");
    });

    this.elements.left.button.className = section === "left" ? "selected" : "";
    this.elements.right.button.className =
      section === "right" ? "selected" : "";

    this.prevToggle = section;
  }

  /**
   * @param {HTMLDivElement} parent
   */
  handlePlayState(parent) {
    let children = parent.querySelectorAll("img");

    if (!children?.length) return;

    if (this.adaptToFirstImage) {
      parent.style.height = children[0].naturalHeight + "px";
    }

    if (children.length <= 1) return;

    const lastChild = children[children.length - 1];
    parent.prepend(lastChild.cloneNode(true));

    children = parent.querySelectorAll("img");

    const handleParentPosition = (x, smooth) => {
      if (smooth)
        parent.style.transition = this.transitionSpeed + "s ease-in-out";
      else parent.style.transition = "unset";

      parent.style.transform =
        "translateX(-" + children[0].offsetWidth * x + "px)";
    };

    let index = 1;
    handleParentPosition(index);

    function playAnimation() {
      if (index === children.length - 1) {
        index = 0;

        handleParentPosition(index);
      }

      void parent.offsetWidth;

      index += 1;
      handleParentPosition(index, true);
    }

    setInterval(() => {
      requestAnimationFrame(playAnimation);
    }, this.intervalSpeed * 1000);
  }
}

customElements.define("banner-carousel", BannerCarousel);
